import { render } from "./NotificationsMenu.vue?vue&type=template&id=5446749c&ts=true"
import script from "./NotificationsMenu.vue?vue&type=script&lang=ts"
export * from "./NotificationsMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__